import React, { useContext } from 'react';
import { merge } from 'lodash';
import { number, bool, object, arrayOf, objectOf, string, instanceOf, element } from 'prop-types';
import { Container } from '@fiverr-private/layout_components';
import DynamicGigCardCarousel from '@fiverr-private/gig_listings/src/entries/DynamicGigCardCarousel';
import { withSelfFetching } from '../../hoc/withSelfFetching';
import PCPContext from '../../utils/context';
import { CarouselHeader } from '../GigsComponentsWrapper/CarouselHeader';
import { CarouselFooter } from '../GigsComponentsWrapper/CarouselFooter';

import './style.scss';
import { EmptyCarousel } from '../../shared/EmptyState/EmptyCarousel';

export const DynamicGigCardCarouselWrapper = (props) => {
    const {
        sectionName,
        headerTitleClass,
        component: { properties = {}, contextEnrichment = {}, items: { gigs = [] } = {} } = {},
        withCarouselHeaderText = true,
        withFooter = true,
        showMoreClassName,
    } = props;
    const dataEnrichment = contextEnrichment.context;
    const pcpContext = useContext(PCPContext);
    const enrichment = merge({}, contextEnrichment, {
        context: {
            pageComponentName: sectionName,
            ...pcpContext,
        },
    });

    const gigComponentProps = {
        ...props,
        ...enrichment,
        gigs,
        isExperiential: true,
    };

    return gigs && gigs.length > 0 ? (
        <div>
            <DynamicGigCardCarousel
                {...gigComponentProps}
                HeaderComponent={
                    <CarouselHeader
                        className="dynamic-gig-card-carousel"
                        titleClassName={headerTitleClass}
                        dataEnrichment={dataEnrichment}
                        withHeaderText={withCarouselHeaderText}
                        showMoreClassName={showMoreClassName}
                        {...properties}
                    />
                }
            />
            {withFooter && <CarouselFooter dataEnrichment={dataEnrichment} {...properties} />}
        </div>
    ) : (
        <Container marginTop="16">
            <EmptyCarousel emptyState={properties.emptyState} dataEnrichment={dataEnrichment} />
        </Container>
    );
};

DynamicGigCardCarouselWrapper.propTypes = {
    sectionName: string,
    component: object.isRequired,
    isLoading: bool,
    isLazy: bool,
    showTranslatedUGC: bool,
    recentlyViewedChoiceGigs: arrayOf(number),
    abTests: object,
    choiceAlgos: objectOf(arrayOf(string)),
    collectProps: object,
    headerTitleClass: string,
    container: instanceOf(element),
    withCarouselHeaderText: bool,
    withFooter: bool,
    showMoreClassName: string,
    excludedBadges: arrayOf(string),
};

DynamicGigCardCarouselWrapper.defaultProps = {
    withCarouselHeader: true,
    isLoading: false,
    isLazy: false,
    showTranslatedUGC: false,
    collectProps: {},
};

export default withSelfFetching(DynamicGigCardCarouselWrapper);
